import BreadCrumbs from 'components/breadcrumbs'
import { Button, Container } from 'reactstrap'
import ModalEndSession from './ModalEndSession'
import ModalEditSession from './ModalEditSession'
import ModalChangeEndOfDay from './ModalChangeEndOfDay'
import {
  toggleModalChangeEndOfDay,
  toggleModalEditSession,
  toggleModalEndSession,
} from './processSlice'
import { Disc, Edit2, MinusSquare, Settings } from 'react-feather'
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { URL_FORM_PROCESS, URL_PROCESS, URL_SESSION_LIST } from 'utils/pathUrl'

const IndexProcess = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const {
    isOpenModalEndSession,
    isOpenModalEditSession,
    isOpenModalChangeEndOfDay,
  } = useSelector((s) => s.process)

  const { sessionProcess, selectedSchema } = useSelector((s) => s.auth)

  const renderBreadcumbs = () => {
    if (location?.pathname === URL_PROCESS) {
      return <BreadCrumbs breadCrumbActive={'Pilih Proses'} />
    } else if (location?.pathname === URL_FORM_PROCESS) {
      return (
        <BreadCrumbs
          breadCrumbParent={'Pilih Proses'}
          breadCrumbParentLink={URL_PROCESS}
          breadCrumbActive={selectedSchema?.label}
        />
      )
    } else if (location?.pathname === URL_SESSION_LIST) {
      return (
        <BreadCrumbs
          breadCrumbParent={'Pilih Proses'}
          breadCrumbParentLink={URL_PROCESS}
          breadCrumbActive="QR Cleaner"
        />
      )
    }
  }

  return (
    <div className="w-100">
      <div className="w-100 px-3">
        <ModalEndSession
          isOpen={isOpenModalEndSession}
          toggle={() => dispatch(toggleModalEndSession())}
          title={sessionProcess?.title}
        />
        <ModalEditSession
          isOpen={isOpenModalEditSession}
          toggle={() => dispatch(toggleModalEditSession())}
          title={sessionProcess?.title}
          sessionProcess={sessionProcess}
        />
        <ModalChangeEndOfDay
          isOpen={isOpenModalChangeEndOfDay}
          toggle={() => dispatch(toggleModalChangeEndOfDay())}
          isEndOfDay={sessionProcess?.isAutoCloseOnEOD}
          project={sessionProcess?.project}
        />
        <Container className="custom-container">
          <div className="pt-3">{renderBreadcumbs()}</div>

          <div className="d-flex align-items-center justify-content-between mb-4">
            <div className="d-flex align-items-center gap-2">
              <div className="badge rounded-pill bg-success-50 text-success px-2 border border-success">
                Aktif
              </div>

              <span className="fw-semibold">
                {sessionProcess?.title}
                <Edit2
                  onClick={() => dispatch(toggleModalEditSession())}
                  size={18}
                  className="ms-2 pointer"
                  data-testid="process-edit-session-button"
                />
              </span>
            </div>

            <div className="d-flex gap-3 align-items-center">
              {/* <MinusSquare
                size={20}
                className="pointer"
                onClick={() => navigate(URL_SESSION_LIST)}
              /> */}

              <Settings
                size={20}
                className="pointer"
                onClick={() => dispatch(toggleModalChangeEndOfDay())}
                data-testid="process-settings-button"
              />

              <Button
                color="danger"
                size="sm"
                onClick={() => dispatch(toggleModalEndSession())}
                data-testid="process-stop-button"
              >
                <Disc size={15} /> STOP
              </Button>
            </div>
          </div>
        </Container>
      </div>
      <Outlet />
    </div>
  )
}

export default IndexProcess
